import { OptionTitle } from "./OptionTitle"

export const GoalTimeframeOptions: Array<OptionTitle> = [
  { id: "NEXT_FEW_DAYS", title: "In the next few days" },
  { id: "NEXT_30_DAYS", title: "In the next 30 days" },
  { id: "NEXT_60_DAYS", title: "In the next 60 days" },
  { id: "LONGER_TIMELINE", title: "Longer timeline" }
]
